import React from 'react';
import './Footer.css';
import { useLanguage } from './LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  return (
    <footer className="site-footer">
      <div>{t('contactSupport')} <a href="mailto:info@izyposmevweb.io">info@izyposmevweb.io</a></div>
      <div className="footer-links">
        <a href="https://www.izyposmevweb.io/privacy-policy" target="_blank" rel="noopener noreferrer">{t('privacyPolicy')}</a> | <a href="https://www.izyposmevweb.io/terms" target="_blank" rel="noopener noreferrer">{t('termsOfService')}</a>
      </div>
      <div> Version - <a href="#">2.0</a></div>
    </footer>
  );
};

export default Footer; 